module.exports = __webpack_public_path__ + "static/media/Burrito.467cb7dd.svg";